import { ImageSlider } from "@tiicker/util/lib/contentful/types";
import SwiperCarousel from "components/Carousel/SwiperCarousel";
import { TiiBubble } from "components/Nft/CoinTiiDisplay/CoinTiiDisplay";
import { Entry } from "contentful";
import React from "react";
import styles from "./ExploreNft.module.scss";

interface Props {
  imageSliders: Entry<ImageSlider>[];
  includes: any;
}

const ExploreNft = (props: Props) => {
  // const sliderRef = useRef<SliderMethods>(null);

  // const handleArrowClick = (direction: "forward" | "reverse") => {
  //   if (direction === "forward") {
  //     sliderRef.current?.slickNext();
  //   } else {
  //     sliderRef.current?.slickPrev();
  //   }
  // };

  // const sliderSettings: Settings = {
  //   centerMode: true,
  //   // infinite: false,
  //   speed: 500,
  //   autoplay: true,
  //   autoplaySpeed: 10000,
  //   // dots: false,
  //   // slidesToShow: 3,
  //   // slidesToScroll: 2,
  //   // initialSlide: 1,
  //   nextArrow: <div></div>,
  //   prevArrow: <div></div>,
  //   responsive: [
  //     {
  //       breakpoint: 5000,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         centerPadding: "400px",
  //       },
  //     },
  //     {
  //       breakpoint: 2200,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,

  //         centerPadding: "200px",
  //       },
  //     },
  //     {
  //       breakpoint: 1850,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 2,
  //         centerPadding: "120px",
  //       },
  //     },
  //     {
  //       breakpoint: 1600,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 2,
  //         centerPadding: "60px",
  //       },
  //     },
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 500,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         centerPadding: "60px",
  //         initialSlide: 0,
  //       },
  //     },
  //   ],
  // };

  return (
    <>
      {props.imageSliders.map((slider) => (
        <>
          {/* <ContentWrapper>
            <h3 className="ExploreNft__title">{slider.fields.header}</h3>
            <div className={styles.ExploreNft__titleBar}>
              <h3 className={styles.ExploreNft__title}>
                {slider.fields.header}
              </h3>
              <div className={styles.ExploreNft__arrows}>
                <img
                  src="/images/nft-carousel-arrow.svg"
                  onClick={() => handleArrowClick("reverse")}
                  className={classNames(
                    styles.ExploreNft__arrow,
                    styles.ExploreNft__arrow__prev
                  )}
                />
                <img
                  src="/images/nft-carousel-arrow.svg"
                  onClick={() => handleArrowClick("forward")}
                  className={styles.ExploreNft__arrow}
                />
              </div>
            </div>
          </ContentWrapper> */}
          {/* <Carousel
            openSide="both"
            ref={sliderRef}
            sliderSettings={sliderSettings}
          >
            {slider.fields.images.map((image) => (
              <div
                className={styles.ExploreNft__imageWrapper}
                key={`slider-image-${image.sys.id}`}
              >
                <TiiBubble
                  className={styles.ExploreNft__imageTag}
                  type="dark"
                  size="sm"
                  text={image.fields.title.toUpperCase()}
                />
                <img
                  className={styles.ExploreNft__image}
                  src={image.fields.file.url}
                />
              </div>
            ))}
          </Carousel> */}
          <SwiperCarousel
            openSide="both"
            // ref={sliderRef}
            // sliderSettings={sliderSettings}
            slideClass={styles.ExploreNft__slide}
            navigation
            navigationLayout="bottom"
            spaceBetween={20}
            slides={slider.fields.images.map((image) => (
              <div
                className={styles.ExploreNft__imageWrapper}
                key={`slider-image-${image.sys.id}`}
              >
                <TiiBubble
                  className={styles.ExploreNft__imageTag}
                  type="dark"
                  size="sm"
                  text={image.fields.title.toUpperCase()}
                />
                <img
                  className={styles.ExploreNft__image}
                  src={image.fields.file.url}
                />
              </div>
            ))}
          />
        </>
        // <div key={`image-slider-${slider.sys.id}`}>
        //   <div className="ExploreNft__titleBar">
        //     <h3 className="ExploreNft__title">{slider.fields.header}</h3>
        //     <div className="ExploreNft__arrows">
        //       <span
        //         onClick={() => offset > 0 && handleArrowClick("reverse")}
        //         className={`ExploreNft__arrow ${
        //           offset === 0 ? "ExploreNft__arrow--deactive" : ""
        //         }`}
        //       >
        //         {"<"}
        //       </span>
        //       <span
        //         onClick={() =>
        //           offset < maxOffset && handleArrowClick("forward")
        //         }
        //         className={`ExploreNft__arrow ${
        //           offset >= maxOffset ? "ExploreNft__arrow--deactive" : ""
        //         }`}
        //       >
        //         {">"}
        //       </span>
        //     </div>
        //   </div>

        //   <div className="ExploreNft__imageWrap">
        //     <div
        //       style={{ transform: `translateX(-${offset}px)` }}
        //       className="ExploreNft__imageFullContainer"
        //     >
        //       <div
        //         className="ExploreNft__imageStretchContainer"
        //         ref={imageWrapperRef}
        //       >
        //         {[1, 2, 3, 4].map((i) => {
        //           return slider.fields.images.map((image) => (
        //             <img
        //               key={`slider-image-${image.sys.id}-${i}`}
        //               className="ExploreNft__image"
        //               src={image.fields.file.url}
        //             />
        //           ));
        //         })}
        //       </div>
        //     </div>
        //   </div>
        // </div>
      ))}
    </>
  );
};

export default ExploreNft;
